<template>
    <base-layout title="隐私设置" :hideFooter="true">
        <template slot="main">
            <div class="page-body">
                <ul>
                    <li>
                        <strong>位置信息权限</strong>
                        <div>
                            <van-switch @change="locationStateChange" v-model="locationState"/>
                        </div>
                    </li>
                </ul>
            </div>
        </template>
    </base-layout>
</template>

<script>
// 页面布局组件
import baseLayout from "@comm/view/layout/baseLayout";
// Vant UI
import {Toast, Switch} from 'vant';
// app dataStore
import appStore from '@comm/store/app.store';

export default {
    name: 'systemSettingPrivacy',
    components: {
        // 页面布局组件
        baseLayout,
        // switch切换组件
        vanSwitch: Switch,
    },
    data() {
        return {
            // 定位状态
            locationState: appStore.state.locationState,
        }
    },
    methods: {
        locationStateChange(state) {
            // 应用内部定位权限状态
            appStore.commit('setLocationState', this.locationState = state);
            if (state) {
                Toast.loading({
                    mask: false,            // 是否显示背景蒙层
                    duration: 0,            // 持续展示 toast
                    forbidClick: true,      // 禁用背景点击
                    loadingType: 'spinner',
                    message: this.$t('address.positioningOn')
                });
                this.$locationMap.getNowLocation(true, true).then(resultInfo => {
                    if (resultInfo.errInfo) {
                        Toast(resultInfo.errInfo.errMsg)
                        // 打开定位引导说明展示控制
                        appStore.commit('openLocationGuideShow', resultInfo.errInfo)
                    } else {
                        Toast('已为您开启位置信息权限')
                    }
                    // 应用内部定位权限状态同步
                    this.locationState = appStore.state.locationState;
                }, resultInfo => {
                    Toast(resultInfo.errInfo.errMsg)
                    // 应用内部定位权限状态同步
                    this.locationState = appStore.state.locationState;
                    // 打开定位引导说明展示控制
                    appStore.commit('openLocationGuideShow', resultInfo.errInfo)
                })
            } else {
                Toast('已为您关闭位置信息权限')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-body {
  padding: 10px;

  ul {
    li {
      display: flex;
      position: relative;
      align-content: center;
      align-items: center;
      height: 1.4rem;
      justify-content: space-between;
      border-bottom: solid 0.025rem #efeff1;

      strong {
        color: #585858;
        font-size: 0.4rem;
        font-weight: normal;
      }
    }
  }
}
</style>